// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3c5rG","inputDescription":"styles_inputDescription__19nDj"};